<div class="h-screen flex w-full surface-ground">
  <!-- Left Side Form Section -->
  <div class="flex flex-1 flex-column surface-ground align-items-center justify-content-center">
    <div class="w-11 sm:w-30rem">
      <!--Header-->
      <div class="flex flex-column">
        <div style="height: 80px; width: 100%" class="flex align-items-center gap-2">
          <img src="assets/layout/images/logos/clearbasin_icon_1-color_04.png" class="flex max-h-4rem" alt=""
               loading="lazy"/>
        </div>
        <div class="mt-4">
          <h1 class="m-0 text-primary font-semibold text-4xl">
            Welcome back!
          </h1>
        </div>
      </div><!--End:Header-->
      <!-- Sign In Form-->
      <form class="flex flex-column mt-4">
        <div class="mt-4">

          <button pButton pRipple class="w-full" icon="pi pi-microsoft" label="SIGN IN" type="button" (click)="signIn()"></button>

        </div>
      </form> <!-- End:Sign In Form-->
    </div>
  </div><!-- End:Left Side Form Section-->
  <!-- Right Side Cover Section-->
  <div class="hidden bg-sand lg:flex flex-1 align-items-center justify-content-center bg-cover">
    <img src="assets/layout/images/logos/clearbasin_horizontal_2-color_03.png" class="max-h-10rem" alt=""
         loading="lazy"/>
  </div><!-- End:Right Side Cover Section-->
</div>
